import React, { useEffect, useState } from "react";
import "./customer.css";

export default function CustomerInfo(props) {
  const { userList, projectList } = props;
  const [adminList, setAdminList] = useState([]);
  const [designerList, setDesignerList] = useState([]);
  const [showAdmin, setShowAdmin] = useState(false);
  const [showCompnayList, setShowCompanyList] = useState(false);
  const [selectAdmin, setSelectAdmin] = useState("Select");

  const [searchList, setSearchList] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (projectList.length > 0) {
      noOfProject(projectList);
    }
    // eslint-disable-next-line
  }, []);

  const noOfProject = (results) => {
    const list = [];
    for (let i = 0; i < userList.length; i++) {
      const element = userList[i];
      const search = element.id;
      const totalProject = results.filter(
        (user) => user.authId && user.authId === search
      );
      const value = {
        id: element.id,
        authId: element.authId ? element.authId : element.id,
        fullName: element.fullName,
        email: element.email,
        password: element.password,
        userType: element.userType,
        phoneNo: element.phoneNo,
        companyName: element.companyName,
        noOfProject: totalProject.length,
      };
      list.push(value);
    }
    if (list.length > 0) {
      getAdminList(list);
    }
  };

  const getAdminList = (list) => {
    const result = list.filter((item) => item.userType === "admin");
    const data = [];
    for (let i = 0; i < result.length; i++) {
      const element = result[i];
      const designerList = list.filter(
        (item) => item.authId === element.id && item.id !== element.id
      );
      const object = {
        designerList,
        ...element,
      };
      data.push(object);
    }
    if (data.length > 0) {
      const sortedArray = data;
      sortedArray.sort((a, b) => {
        const nameA = a.fullName.toLowerCase();
        const nameB = b.fullName.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      setAdminList(sortedArray);
      setSearchList(sortedArray);
    }
  };

  const handleAdmin = (item) => {
    setDesignerList(item.designerList);
    setSelectAdmin(item);
    if (item.designerList.length === 0) {
      alert("No Designer ID create by admin yet.");
    }
  };

  const handleSearchInput = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchValue(e.target.value);
    if (searchTerm.length > 0) {
      const filtered = searchList.filter((user) => {
        const fullName = user.fullName.toLowerCase();
        const companyName = user.companyName.toLowerCase();
        const email = user.email.toLowerCase();
        return (
          fullName.includes(searchTerm) ||
          companyName.includes(searchTerm) ||
          email.includes(searchTerm)
        );
      });
      const sortedArray = filtered;
      sortedArray.sort((a, b) => {
        const nameA = a.fullName.toLowerCase();
        const nameB = b.fullName.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      setAdminList(filtered);
    } else {
      setAdminList(searchList);
    }
  };

  const [timeInfo] = useState({
    createAt: "",
    lastLogin: "",
  });

  return (
    <>
      <div className="customerAnalytics">
        <h1>Customer Analytics({searchList.length})</h1>
        <div className="analyticsHead">
          <div className="anlyticsList">
            <div className="formWithLabel">
              <label>Customer Admin List</label>
              <div
                className="selectOption"
                onMouseLeave={() => setShowAdmin(false)}
              >
                <ul id="first" name="module">
                  <li onClick={() => setShowAdmin(!showAdmin)}>
                    {selectAdmin.fullName}.
                    <i className="bi bi-chevron-down"></i>
                  </li>
                  {showAdmin && (
                    <div
                      className="dropDown"
                      onMouseLeave={() => setShowAdmin(false)}
                    >
                      {adminList &&
                        adminList.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => handleAdmin(item)}
                            style={
                              selectAdmin.id === item.id
                                ? { backgroundColor: "blue", color: "white" }
                                : {}
                            }
                          >
                            {item.fullName}
                          </li>
                        ))}
                    </div>
                  )}
                </ul>
              </div>
            </div>
            <div className="formWithLabel">
              <label>Customer Comapny List</label>
              <div
                className="selectOption"
                onMouseLeave={() => setShowCompanyList(false)}
              >
                <ul id="first" name="module">
                  <li onClick={() => setShowCompanyList(!showCompnayList)}>
                    {selectAdmin.companyName}.
                    <i className="bi bi-chevron-down"></i>
                  </li>
                  {showCompnayList && (
                    <div
                      className="dropDown"
                      onMouseLeave={() => setShowCompanyList(false)}
                    >
                      {adminList &&
                        adminList.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => handleAdmin(item)}
                            style={
                              selectAdmin.id === item.id
                                ? { backgroundColor: "blue", color: "white" }
                                : {}
                            }
                          >
                            {item.companyName}
                          </li>
                        ))}
                    </div>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="formWithLabel">
            <label>Search by Customer&Company Name</label>
            <input
              value={searchValue}
              onChange={(e) => handleSearchInput(e)}
            ></input>
          </div>
        </div>

        <div style={{ overflowX: "scroll", width: "100%" }}>
          <div className="table">
            <ul className="head">
              <li>Admin Name</li>
              <li>Admin Email</li>
              <li>Phone No</li>
              <li>User Type</li>
              <li>Company Name</li>
              <li>No Of Project</li>
            </ul>
            {adminList.map((item, index) => (
              <React.Fragment key={index}>
                <ul
                  className={
                    selectAdmin.id === item.id ? `body selectID` : `body`
                  }
                  // onClick={() => getDesignerList(item)}
                >
                  <li>{item.fullName}</li>
                  <li>{item.email}</li>
                  <li>{item.phoneNo}</li>
                  <li>{item.userType}</li>
                  <li>{item.companyName}</li>
                  <li>{item.noOfProject} </li>
                </ul>
                
                {selectAdmin.id === item.id && (
                  <div className="subIDS">
                    <ul className="creationTime">
                      <li>Create Time: {timeInfo.createAt}</li>
                      <li>Last Login Time: {timeInfo.lastLogin}</li>
                    </ul>
                  </div>
                )}
                {designerList.length > 0 && selectAdmin.id === item.id && (
                  <div className="subIDS">
                    <ul className="head">
                      <li>Designer Name</li>
                      <li>Designer Email</li>
                      <li>Phone No</li>
                      <li>User Type</li>
                      <li>Company Name</li>
                      <li>No Of Project</li>
                    </ul>
                    {designerList.map((ite, index) => (
                      <ul className="body" key={index}>
                        <li>{ite.fullName}</li>
                        <li>{ite.email}</li>
                        <li>{ite.phoneNo}</li>
                        <li>{ite.userType}</li>
                        <li>{ite.companyName}</li>
                        <li>{ite.noOfProject}</li>
                      </ul>
                    ))}
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
